import { baseDashboard, baseMyJourneys, baseTasks, SidebarSection } from "./shared";

const teammateSidebarItems: SidebarSection[] = [
  { id: "top", items: [baseDashboard, baseTasks, baseMyJourneys] },
];

export default teammateSidebarItems;
